import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import * as ClassicEditor from 'src/assets/js/ck-editor/ckeditor.js';
import { TermIndexService } from 'src/app/services/term-index.service';
import { CNConsultation } from 'src/app/models/cnconsultation';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-contact-editor',
  templateUrl: './contact-editor.component.html',
  styleUrls: ['./contact-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactEditorComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() contact: CNConsultation;
  @ViewChild('editor', {static: true}) ckEditor: ElementRef;

  private contentEditor: typeof ClassicEditor;
  private searchSub: Subscription;

  constructor(private termIndex: TermIndexService, private changeDetection: ChangeDetectorRef) { }

  ngOnInit(): void {
    const allFeeds = [];
    // Prebuild all feeds with first letter
    for (let i = 65 ; i <= 90 ; i++ ) {
      allFeeds.push({
        marker: String.fromCharCode(i),
        feed: this.getFeedItems,
        minimumCharacters: 1
      });
    }
    for (let i = 97 ; i <= 122 ; i++ ) {
      allFeeds.push({
        marker: String.fromCharCode(i),
        feed: this.getFeedItems,
        minimumCharacters: 1
      });
    }
    ClassicEditor
      .create( this.ckEditor.nativeElement, {
        mention: {
          dropdownLimit: Infinity,
          feeds: allFeeds
        }
      })
      .then( editor => {
        this.contentEditor = editor;
        this.contentEditor.content = this;
        console.log('editor', this.contentEditor);
        if (this.contact) {
          this.contentEditor.setData(this.contact.value);
          this.contentEditor.model.document.on('change:data', () => {
            this.contact.setValue(this.contentEditor.getData());
          });
        }
      })
      .catch( error => {
          console.error( error );
      });
  }

  ngOnDestroy(): void {
    if (this.searchSub) {
      this.searchSub.unsubscribe();
    }
    this.contentEditor.destroy().then(() => {
      console.log('ckeditor destroyed');
    });
  }

  ngAfterViewInit(): void {
    console.log('AfterViewInit');
    if (this.contentEditor && this.contact) {
      this.contentEditor.setData(this.contact.value);
    }
  }

  getFeedItems(queryText: string) {
    return new Promise( resolve => {
      setTimeout( () => {
        const search = queryText.toLowerCase();
        if (this.searchSub) {
          this.searchSub.unsubscribe();
        }
        this.searchSub = ((this as any).content.termIndex as TermIndexService).search(search).subscribe(results => {
          resolve(results);
        });
      }, 100);
    } );
  }

}
